import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { toast } from "react-toastify";
import AddRouteMaster from "./AddRouteMaster";
import EditRouteMaster from "./EditRouteMaster";
import ExportRouteMaster from "./ExportRouteMaster";
import RouteMasterTable from "./RouteMasterTable";
import { useRouteMasterStore } from "./RouteMasterStore/useRouteMasterStore";

const RouteMasterRootComponent = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const {
    filteredRoutes,
    searchTerm,
    isLoading,
    pagination,
    setSearchTerm,
    setPage,
    setPageSize,
  } = useRouteMasterStore();

  useEffect(() => {
    useRouteMasterStore.getState().fetchRoutes();
  }, []);

  const handleAdd = () => {
    setShowAddModal(true);
  };

  const handleEdit = (row) => {
    setEditRow(row);
    setShowEditModal(true);
  };

  const handleUploadKml = () => {
    toast.info("Upload KML will be available in the next update.");
  };

  return (
    <>
      <div className="content text-start">
        <div className="page-content">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
            <div>
              <h5 className="mb-1 fw-semibold">All Route Information</h5>
             
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <button type="button" className="button-container" onClick={handleAdd}>
                <FaPlus className="font-size-20 me-1" /> Add Route
              </button>
              <ExportRouteMaster routeData={filteredRoutes} />
              {/* <button
                type="button"
                className="button-container ms-3"
                onClick={handleUploadKml}
              >
                <i className="fa-solid fa-upload me-1 icon-container"></i> Upload KML
              </button> */}
            </div>
          </div>

          <div className="card shadow mt-3">
            <div className="card-body">
              <RouteMasterTable
                loading={isLoading}
                rows={filteredRoutes}
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                pagination={pagination}
                onPageChange={setPage}
                onPageSizeChange={setPageSize}
                onEdit={handleEdit}
              />
            </div>
          </div>
        </div>
      </div>

      <AddRouteMaster
        showModal={showAddModal}
        setShowModal={setShowAddModal}
        isEditMode={false}
      />

      <EditRouteMaster
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        editRow={editRow}
      />
    </>
  );
};

export default RouteMasterRootComponent;
